import { defineStore } from "pinia";
import { DRAWER_PLACEMENT, DRAWER_MOBILE_OFFSET, DRAWER_OFFSET } from "../uikit.components/Drawer/drawer.es.js";
const DEFAULT_DRAWER = {
  id: "default",
  component: null,
  props: {},
  instance: null
};
const useDrawerStore = defineStore("uikit-drawer", {
  state: () => ({
    drawers: []
  }),
  getters: {
    offset: (state) => (id, placement) => {
      var _a, _b;
      if ([DRAWER_PLACEMENT.RIGHT, DRAWER_PLACEMENT.LEFT].includes(placement)) {
        let offset = 0;
        for (let i = state.drawers.length - 1; i > 0; --i) {
          const drawer = state.drawers[i];
          if (drawer.id === id.toLowerCase()) {
            break;
          }
          offset += DRAWER_OFFSET;
        }
        return offset * (placement === DRAWER_PLACEMENT.LEFT ? 1 : -1);
      } else if ([DRAWER_PLACEMENT.TOP, DRAWER_PLACEMENT.BOTTOM].includes(placement)) {
        const index = state.drawers.findIndex((drawer) => drawer.id === id.toLowerCase());
        const isActiveDrawer = index !== -1 && index === state.drawers.length - 1;
        let offset = 0;
        if (isActiveDrawer) {
          offset = DRAWER_MOBILE_OFFSET;
        } else {
          const activeDrawer = state.drawers[state.drawers.length - 1];
          if (activeDrawer && ((_a = activeDrawer == null ? void 0 : activeDrawer.instance) == null ? void 0 : _a.height)) {
            const factors = [0.7, 1.2, 1.5, 1.8];
            const indexInner = state.drawers.length - index - 1;
            offset = ((_b = activeDrawer == null ? void 0 : activeDrawer.instance) == null ? void 0 : _b.height) + DRAWER_MOBILE_OFFSET * factors[indexInner - 1];
          }
        }
        return offset * (placement === DRAWER_PLACEMENT.BOTTOM ? 1 : -1);
      }
    },
    isActive: (state) => (id) => {
      const index = state.drawers.findIndex((drawer) => drawer.id === id.toLowerCase());
      return index !== -1 && index === state.drawers.length - 1;
    },
    isVisible: (state) => (id) => !!state.drawers.find((drawer) => drawer.id === id.toLowerCase()),
    visibleDrawers: (state) => state.drawers
  },
  actions: {
    addDrawer(drawer = DEFAULT_DRAWER) {
      const { id, component, props } = { ...DEFAULT_DRAWER, ...drawer };
      const idDrawer = id.toLowerCase();
      if (this.drawers.some((drawer2) => drawer2.id === idDrawer)) {
        this.drawers = this.drawers.filter((drawer2) => drawer2.id !== idDrawer);
      }
      this.drawers.push({
        id: idDrawer,
        component,
        props: { ...props, id: idDrawer }
      });
    },
    referenceInstance(id, instance) {
      const drawer = this.drawers.find((drawer2) => drawer2.id === id.toLowerCase());
      if (drawer) {
        drawer.instance = instance;
      }
    },
    removeDrawer(drawer = { id: "default" }) {
      const { id } = drawer;
      this.drawers = this.drawers.filter((drawer2) => drawer2.id !== id.toLowerCase());
    },
    removeAll() {
      this.drawers = [];
    }
  }
});
export {
  useDrawerStore
};
//# sourceMappingURL=drawer.es.js.map
